/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Sync_ReferenceInputs */

const vi_expense_sync_reference = /** @type {(inputs: Expense_Sync_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã tham chiếu`)
};

/**

* @param {Expense_Sync_ReferenceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_sync_reference = /** @type {((inputs?: Expense_Sync_ReferenceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Sync_ReferenceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_sync_reference(inputs)
});